import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme=>({
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 300,
    },
    checkedColor:{
        '&>.MuiCheckbox-colorSecondary.Mui-checked':{
            color: 'green'
        }        
    }
}))